export const NOT_FOUND = '/404'
export const FORBIDDEN = '/403'
export const SIGNIN_REDIRECT = '/signin-oidc'
export const FIRST_SIGNIN = '/first-signin'
export const LOGIN_FAILED = '/login-failed'
export const SIGN_OUT = '/sign-out'

export const ACCOUNTS = '/accounts'

export const REDIRECT_TO_HOMEPAGE = '/accounts/:accountId/redirect-to-home'
export const HOMEPAGE = '/accounts/:accountId/projects/:projectId/home'

export const ALERTS_MATERIAL_CERTIFICATIONS_TABLE =
  '/accounts/:accountId/projects/:projectId/alerts/material-certifications'

export const ALERTS_QUALITY_ASSURANCE_TABLE =
  '/accounts/:accountId/projects/:projectId/alerts/quality-assurance'

export const ALERTS_SUBMISSION_ISSUES_TABLE =
  '/accounts/:accountId/projects/:projectId/alerts/submission-issues'

export const ALERTS_WASTE_COMPLIANCE_TABLE =
  '/accounts/:accountId/projects/:projectId/alerts/waste-compliance'

export const ASSIGNEE_NO_RECORDS_LANDING =
  '/accounts/:accountId/no-assigned-records'

export const PROJECTSETTINGS =
  '/accounts/:accountId/projects/:projectId/settings'

export const REPORTS = '/accounts/:accountId/reports'

export const DELIVERY = '/accounts/:accountId/projects/:projectId/delivery/'
export const DELIVERY_ROOT = '/accounts/:accountId/projects/:projectId/delivery'
export const DELIVERY_DEFAULT =
  '/accounts/:accountId/projects/:projectId/delivery/table'
export const DELIVERY_TABLE =
  '/accounts/:accountId/projects/:projectId/delivery/table'
export const DELIVERY_EVENTS =
  '/accounts/:accountId/projects/:projectId/delivery/events'
export const DELIVERY_RECORD_DETAILS =
  '/accounts/:accountId/projects/:projectId/delivery/record/:recordId'
export const DELIVERY_RECORD_EDIT =
  '/accounts/:accountId/projects/:projectId/delivery/record/:recordId/edit'
export const DELIVERY_RECORD_LINE_ITEM_EDIT =
  '/accounts/:accountId/projects/:projectId/delivery/record/:recordId/edit/item/:lineItem'
export const DELIVERY_TABS = {
  EVENTS: 'events',
  TABLE: 'table',
  DASHBOARD: 'dashboard'
}

export const WASTE = '/accounts/:accountId/projects/:projectId/waste/table'
export const WASTE_ROOT = '/accounts/:accountId/projects/:projectId/waste'
export const WASTE_DEFAULT =
  '/accounts/:accountId/projects/:projectId/waste/table'
export const WASTE_TABLE =
  '/accounts/:accountId/projects/:projectId/waste/table'
export const WASTE_EVENTS =
  '/accounts/:accountId/projects/:projectId/waste/events'
export const WASTE_RECORD_DETAILS =
  '/accounts/:accountId/projects/:projectId/waste/record/:recordId'
export const WASTE_RECORD_EDIT =
  '/accounts/:accountId/projects/:projectId/waste/record/:recordId/edit'
export const WASTE_RECORD_LINE_ITEM_EDIT =
  '/accounts/:accountId/projects/:projectId/waste/record/:recordId/edit/item/:lineItem'
export const WASTE_TABS = {
  EVENTS: 'events',
  TABLE: 'table',
  DASHBOARD: 'dashboard'
}

export const BI_REPORT = '/accounts/:accountId/bireport/:reportType'

export const BASE_MODULE_NAV =
  '/accounts/:accountId/projects/:projectId/:moduleName'

export const ACCOUNT_SETTINGS = '/accounts/:accountId/accountSettings'

/** @enum {string} */
export const DESTINATION_TYPES = {
  ALERT: 'alert',
  RECORD: 'record',
  REPORT: 'report'
}
export const RECEIVED_DESTINATION =
  '/destination/:destinationType/:destinationId'

export const UTILITIES_READINGS =
  '/accounts/:accountId/projects/:projectId/utilities/readings'
export const UTILITIES_METERS =
  '/accounts/:accountId/projects/:projectId/utilities/meters'
export const UTILITIES_EVENTS =
  '/accounts/:accountId/projects/:projectId/utilities/events'
